Vue.component('v-getapp', {
  mounted: function () {
    var ios = 'https://apps.apple.com/ru/app/%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%B0-%D1%80%D0%BE%D1%81%D1%81%D0%B8%D0%B8/id1550617710?l=en&platform=iphone'
    var android = 'https://play.google.com/store/apps/details?id=ru.trudvsem.mobile'
    var os = this.getMobileOperatingSystem()
    console.log('os', os)
    if (os === 'ios')
      window.location.href = ios;
    else
      window.location.href = android;
  },
  methods: {
    getMobileOperatingSystem: function() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }

      return "unknown";
    }
  }
})
